export const ADD_MULTIPLE = 'entities/walletTransaction/ADD_MULTIPLE';
